import { render, staticRenderFns } from "./ValidateTextareaComponent.vue?vue&type=template&id=bf65e272&scoped=true&"
import script from "./ValidateTextareaComponent.vue?vue&type=script&lang=js&"
export * from "./ValidateTextareaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf65e272",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
